// Theme system — REDE Platform v2 aligned
export const APP_VERSION = '4.15.0';

export const darkVars = {
  '--bg':'#0F172A','--panel':'#1E293B','--card':'#1E293B','--bg-input':'#1E293B',
  '--border':'#334155',
  '--text':'#F1F5F9','--text-soft':'#CBD5E1','--muted':'#94A3B8','--faint':'#475569',
  '--accent':'#22C55E','--gold':'#D4A843',
  '--positive':'#22C55E','--negative':'#EF4444','--warning':'#F59E0B',
  '--blue':'#3B82F6','--purple':'#8B5CF6',
  '--card-shadow':'0 1px 3px rgba(0,0,0,0.3), 0 4px 12px rgba(0,0,0,0.15)',
  '--shadow-sm':'0 1px 2px rgba(0,0,0,0.2)',
  '--nav-bg':'#1E293B','--tooltip-bg':'#1E293B','--tooltip-border':'#334155',
  '--focus-ring':'0 0 0 3px rgba(34,197,94,0.22)',
  '--radius':'12px','--radius-sm':'8px',
  // Legacy compat
  '--bg-primary':'#0F172A','--bg-secondary':'#1E293B','--bg-card':'#1E293B',
  '--bg-subtle':'rgba(34,197,94,0.08)','--bg-hover':'rgba(30,41,59,0.8)',
  '--border-primary':'#334155','--border-accent':'rgba(34,197,94,0.25)',
  '--text-primary':'#F1F5F9','--text-secondary':'#CBD5E1','--text-muted':'#94A3B8',
  '--text-faint':'#475569','--text-dim':'#334155',
  '--green':'#22C55E','--red':'#EF4444',
  '--input-bg':'#1E293B','--chart-grid':'rgba(255,255,255,0.06)',
  '--gold-subtle':'rgba(212,168,67,0.12)',
  '--gold-bright':'#C8962E',
  '--gold-border':'rgba(154,120,32,0.2)',
};

export const lightVars = {
  '--bg':'#F1F5F9','--panel':'#FFFFFF','--card':'#FFFFFF','--bg-input':'#FFFFFF',
  '--border':'#E2E8F0',
  '--text':'#0F172A','--text-soft':'#475569','--muted':'#64748B','--faint':'#94A3B8',
  '--accent':'#16A34A','--gold':'#9A7820',
  '--positive':'#16A34A','--negative':'#DC2626','--warning':'#F59E0B',
  '--blue':'#2563EB','--purple':'#7C3AED',
  '--card-shadow':'0 1px 3px rgba(0,0,0,0.1), 0 4px 16px rgba(0,0,0,0.06)',
  '--shadow-sm':'0 1px 2px rgba(0,0,0,0.05)',
  '--nav-bg':'#FFFFFF','--tooltip-bg':'#FFFFFF','--tooltip-border':'#E2E8F0',
  '--focus-ring':'0 0 0 3px rgba(22,163,74,0.22)',
  '--radius':'12px','--radius-sm':'8px',
  // Legacy compat
  '--bg-primary':'#F1F5F9','--bg-secondary':'#FFFFFF','--bg-card':'#FFFFFF',
  '--bg-subtle':'rgba(22,163,74,0.06)','--bg-hover':'#F8FAFC',
  '--border-primary':'#E2E8F0','--border-accent':'rgba(22,163,74,0.3)',
  '--text-primary':'#0F172A','--text-secondary':'#475569','--text-muted':'#64748B',
  '--text-faint':'#94A3B8','--text-dim':'#CBD5E1',
  '--green':'#16A34A','--red':'#DC2626',
  '--input-bg':'#FFFFFF','--chart-grid':'#E2E8F0',
  '--gold-subtle':'rgba(154,120,32,0.08)',
  '--gold-bright':'#C8962E',
  '--gold-border':'rgba(154,120,32,0.2)',
};

export const chartColors = (dark) => ({
  accent: dark ? '#22C55E' : '#16A34A',
  blue: dark ? '#3B82F6' : '#2563EB',
  purple: dark ? '#8B5CF6' : '#7C3AED',
  red: dark ? '#EF4444' : '#DC2626',
  gold: dark ? '#D4A843' : '#9A7820',
  grid: dark ? 'rgba(255,255,255,0.06)' : '#E2E8F0',
  muted: dark ? '#94A3B8' : '#64748B',
  orange: '#F97316',
  teal: '#14B8A6',
});
